import {
  aCountsByVendorAndProductDataPoint,
  aRecordCountsByParsedDataPoint,
  mockLogMappingRecordMetricsQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockLogMappingRecordMetricsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          recordCountsByParsed: [aRecordCountsByParsedDataPoint()],
          recordCountsByVendorAndProduct: [
            aCountsByVendorAndProductDataPoint(),
          ],
          signalCountsByVendorAndProduct: [
            aCountsByVendorAndProductDataPoint(),
          ],
        },
      });
    }
  ),
];
